function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState as $9gyGR$useState } from "react";
import { useLayoutEffect as $9gyGR$useLayoutEffect } from "@radix-ui/react-use-layout-effect";
function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
  var _$9gyGR$useState = $9gyGR$useState(undefined),
    _$9gyGR$useState2 = _slicedToArray(_$9gyGR$useState, 2),
    size = _$9gyGR$useState2[0],
    setSize = _$9gyGR$useState2[1];
  $9gyGR$useLayoutEffect(function () {
    if (element) {
      // provide size as early as possible
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
      var resizeObserver = new ResizeObserver(function (entries) {
        if (!Array.isArray(entries)) return;
        // Since we only observe the one element, we don't need to loop over the
        // array
        if (!entries.length) return;
        var entry = entries[0];
        var width;
        var height;
        if ('borderBoxSize' in entry) {
          var borderSizeEntry = entry['borderBoxSize']; // iron out differences between browsers
          var borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize['inlineSize'];
          height = borderSize['blockSize'];
        } else {
          // for browsers that don't support `borderBoxSize`
          // we calculate it ourselves to get the correct border box.
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({
          width: width,
          height: height
        });
      });
      resizeObserver.observe(element, {
        box: 'border-box'
      });
      return function () {
        return resizeObserver.unobserve(element);
      };
    } else
      // We only want to reset to `undefined` when the element becomes `null`,
      // not if it changes to another element.
      setSize(undefined);
  }, [element]);
  return size;
}
export { $db6c3485150b8e66$export$1ab7ae714698c4b8 as useSize };